// extracted by mini-css-extract-plugin
export default {"inputField":"violationsColumns_inputField__Xty0t"};